<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
// NFA-VPS Cart Validation - Prevent Buy Again bypass
(function() {
  function checkNFAVPSProperties() {
    fetch('/cart.json')
      .then(res => res.json())
      .then(cart => {
        const checks = cart.items.map(function(item) {
          return fetch('/products/' + item.handle + '.js')
            .then(r => r.json())
            .then(product => {
              const tags = product.tags || [];
              const isNFA = tags.map(t => t.toLowerCase().trim()).includes('nfa-vps');
              if (!isNFA) return false;
              const props = item.properties || {};
              const petName = (props['Pet Name'] || '').trim();
              const species = (props['Species'] || '').trim();
              return petName === '' || species === '';
            });
        });

        Promise.all(checks).then(function(results) {
          const hasInvalidItem = results.includes(true);
          const checkoutBtn = document.querySelector('#cart-checkout');
          const checkoutLinkBtn = document.querySelector('a.button-checkout');
          let warningEl = document.getElementById('nfa-vps-warning');

          if (hasInvalidItem) {
            if (!warningEl) {
              warningEl = document.createElement('div');
              warningEl.id = 'nfa-vps-warning';
              warningEl.style.cssText = 'background:#fff3cd;border:1px solid #ffc107;color:#856404;padding:12px 16px;margin:16px 0;border-radius:4px;font-size:14px;line-height:1.5;';
              warningEl.innerHTML = '⚠️ <strong>Action Required:</strong> One or more items in your basket require pet information to be completed. Please visit the product page to fill in the required details before proceeding to checkout.';
              document.querySelector('.action-group').insertAdjacentElement('beforebegin', warningEl);
            }
            if (checkoutBtn) {
              checkoutBtn.disabled = true;
              checkoutBtn.style.opacity = '0.4';
              checkoutBtn.style.pointerEvents = 'none';
            }
            if (checkoutLinkBtn) {
              checkoutLinkBtn.style.opacity = '0.4';
              checkoutLinkBtn.style.pointerEvents = 'none';
            }
          } else {
            if (warningEl) warningEl.remove();
            if (checkoutBtn) {
              checkoutBtn.disabled = false;
              checkoutBtn.style.opacity = '';
              checkoutBtn.style.pointerEvents = '';
            }
            if (checkoutLinkBtn) {
              checkoutLinkBtn.style.opacity = '';
              checkoutLinkBtn.style.pointerEvents = '';
            }
          }
        });
      });
  }

  if (window.location.pathname === '/cart') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', checkNFAVPSProperties);
    } else {
      checkNFAVPSProperties();
    }
  }
})();